module.exports = __webpack_public_path__ + "img/Psychologist_1.9e2e46e7.png";